<template>
  <div id="container">
    <div
      class="item-box-content"
      style="padding:10px 20px;">
      <div style="display: flex;justify-content: space-between;align-items: center">
        <div class="title-font-style">
          <span>企业银行账号</span>
        </div>
        <el-button
          type="primary"
          plain
          @click="onAddOrEditUnit(1)">新增账号
        </el-button>
      </div>
    </div>
    <!-------------- 列表 -------------->
    <div
      class="item-box-content"
      style="margin-bottom: 0">
      <div :style="{height:tableHeight + 'px'}">
        <el-table
          border
          ref="tableRef"
          :data="list"
          :max-height="tableHeight"
          tooltip-effect="dark"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          row-key="id"
          element-loading-text="拼命加载中请稍后..."
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column
            prop="sort"
            label="序号"
            type="sort"
            width="100px"></el-table-column>
          <el-table-column
            prop="bankUserName"
            label="账户名称"></el-table-column>
          <el-table-column
            prop="bankOpenName"
            label="开户行"></el-table-column>
          <el-table-column
            prop="bankNumber"
            label="银行行号"></el-table-column>
          <el-table-column
            prop="bankCode"
            label="银行账号"></el-table-column>
          <el-table-column
            label="操作"
            width="110px">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="onAddOrEditUnit(2,scope.row)">修改
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop
            label="是否启用"
            width="120px">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.isShow"
                @change="selectItem(scope.row)"
                active-color="#276CFF"
              ></el-switch>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 20px;display: flex;justify-content: space-between">
        <div style="display: flex;flex: 1;align-items: center">
          <i
            class="el-icon-warning-outline"
            style="color:#D35E5E;font-size: 16px;vertical-align: middle;padding-right: 6px;"
          ></i>
          <span style="color:#D35E5E">提示：排序越靠前越方便选择，可以通过拖动进行调整顺序！</span>
        </div>
        <div
          class="pagination"
          style="flex: 1;">
          <pagination
            :total="total"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
          ></pagination>
        </div>
      </div>

    </div>
    <!-------------- 新增/更改银行账号信息 -------------->
    <add-bank-account ref="addEditBrandRefs"></add-bank-account>
  </div>
</template>

<script>
  import {
    isEnableEnterPrise,
    updateEnterPrise,
    getEnterpriseList,
    getBankSort
  } from '@/api/system/rightsManagement'
  // import { expressionList } from '@/components/utils/data'
  import pagination from '@/components/pagination'
  import addBankAccount from '../dialog/addBankAccount'
  import Sortable from 'sortablejs'

  var _this
  // import OpenOrClose from '@/components/OpenOrClose/index'
  export default {
    components: {
      pagination,
      'add-bank-account': addBankAccount
    },
    data () {
      return {
        queryParams: {},
        params: {},
        tableHeight: window.innerHeight - 320,
        contractScreenCondition: [],
        // expressionList: expressionList,
        loadingTable: false, // 列表loading
        list: [], // 列表数据
        pageSize: 30, // 页数
        currentPage: 1, // 页码
        total: 0, // 列表总数
        value1: false,
        value2: true
      }
    },
    mounted () {
      _this = this
      _this.getInit()
      document.body.ondrop = function (event) {
        event.preventDefault()
        event.stopPropagation()
      }
      this.rowDrop()
    },
    methods: {
      rowDrop () {
        const tbody = document.querySelector('.el-table__body-wrapper tbody')
        const _this = this
        Sortable.create(tbody, {
          onEnd ({ newIndex, oldIndex }) {

            const currRow = _this.list.splice(oldIndex, 1)[0]
            _this.list.splice(newIndex, 0, currRow)
            _this.list.forEach((res, index) => {
              _this.$set(res, 'sort', index + 1)
            })
            getBankSort({
              financeBankInfoList: [..._this.list]
            }).then(res => {
              _this.$message({
                message: res.data.msg,
                type: res.data.code === 200 ? 'success' : 'error'
              })
            })
          }
        })
      },
      selectItem (row) {
        const { isShow, id } = row
        isEnableEnterPrise(id, Number(isShow)).then(res => {
          let isflag = true
          if (res.data.code !== 200) {
            isflag = false
          }
          this.$message({
            message: isflag
              ? `${isShow ? '启用' : '停用'}操作成功`
              : `${isShow ? '启用' : '停用'}操作失败`,
            type: isflag ? 'success' : 'error'
          })
        })
      },
      getInit: async () => {
        const { currentPage, pageSize } = _this
        const response = await getEnterpriseList(currentPage, pageSize)
        _this.list = response.data.obj.records
        _this.total = response.data.obj.total

        _this.list.forEach((v, i) => {
          _this.$set(v, 'index', i + 1)
          if (v.flag) {
            _this.$set(v, 'isShow', true)
          } else {
            _this.$set(v, 'isShow', false)
          }
          // _this.$set(v,'isShow',false)
        })
      },
      // 新增物流信息窗口
      onAddOrEditUnit (type, row) {
        this.$refs.addEditBrandRefs.onInitialize(type, row)
      },
      // 设置头部背景色
      tableHeader ({ rowIndex }) {
        return this.$tableHeader(rowIndex)
      },
      // 页数
      handleSizeChange (val) {
        this.pageSize = val
        // this.getList()
        this.getInit()
      },
      // 页码
      handleCurrentChange (val) {
        this.currentPage = val
        // this.getList()
        this.getInit()
      }
    }
  }
</script>

<style
  lang="scss"
  scoped>
  .search-style {
    padding: 10px 20px 10px 30px;
  }

  ::v-deep .org-tree-node-label {
    overflow: hidden !important;
  }

  .pagination > div {
    padding-bottom: 0 !important;
  }
</style>
